function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self1 = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self1, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { ShakaEcmaScriptVersion, ShakaPlayerVersion } from '../../config/internal-config';
import { TextTrackMimeType } from '../../core/player/text-track-mime-type';
import { isSafariDesktop } from '../../utils/device-type';
import { MINIMUM_VERSION_FOR_NEW_CEA_PARSER, isVersionCompliant } from './shaka-version-utils';
import { TestingOverrides } from '../../core/services/testing-overrides';
import { ShakaBundle } from './shaka.enums';
export { ShakaBundle } from './shaka.enums';
var shakaWindow = self;
export function loadShaka(_) {
    return _loadShaka.apply(this, arguments);
}
function _loadShaka() {
    _loadShaka = _async_to_generator(function(param) {
        var _param_shakaPlayerVersion, shakaPlayerVersion, _param_useMuxJS, useMuxJS, _param_esVersion, esVersion, _param_subtitlesFormat, subtitlesFormat, device, _param_useDebug, useDebug;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    _param_shakaPlayerVersion = param.shakaPlayerVersion, shakaPlayerVersion = _param_shakaPlayerVersion === void 0 ? undefined : _param_shakaPlayerVersion, _param_useMuxJS = param.useMuxJS, useMuxJS = _param_useMuxJS === void 0 ? false : _param_useMuxJS, _param_esVersion = param.esVersion, esVersion = _param_esVersion === void 0 ? ShakaEcmaScriptVersion.ES5 : _param_esVersion, _param_subtitlesFormat = param.subtitlesFormat, subtitlesFormat = _param_subtitlesFormat === void 0 ? [] : _param_subtitlesFormat, device = param.device, _param_useDebug = param.useDebug, useDebug = _param_useDebug === void 0 ? false : _param_useDebug;
                    if (!shakaPlayerVersion) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        loadShakaVersionBundle(getShakaBundle(esVersion, subtitlesFormat, useDebug, device), shakaPlayerVersion)
                    ];
                case 1:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap" */ '@sky-uk-ott/shaka-player-3-0-5')
                    ];
                case 3:
                    self.shaka = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        4,
                        loadMuxJS(shaka.Player.version, useMuxJS)
                    ];
                case 5:
                    _state.sent();
                    return [
                        2,
                        self.shaka
                    ];
            }
        });
    });
    return _loadShaka.apply(this, arguments);
}
export function getShakaBundle(esVersion, subtitlesFormat, useDebug, device) {
    var shakaBundle = ShakaBundle.ALL;
    if (TestingOverrides.uncompiledShaka) {
        return ShakaBundle.UNCOMPILED;
    }
    if (useDebug) {
        return ShakaBundle.DEBUG;
    }
    var isSafari = device ? isSafariDesktop(device.deviceInfo, device.type) : false;
    if (isSafari) {
        shakaBundle = getHlsBundle(esVersion);
    } else {
        var needsTTML = subtitlesFormat.includes(TextTrackMimeType.TTML);
        var needsVTT = subtitlesFormat.includes(TextTrackMimeType.WebVTT);
        if (needsTTML && !needsVTT) {
            shakaBundle = getDashTTMLBundle(esVersion);
        } else if (needsVTT && !needsTTML) {
            shakaBundle = getDashVTTBundle(esVersion);
        } else {
            shakaBundle = getAllBundle(esVersion);
        }
    }
    return shakaBundle;
}
function loadShakaVersionBundle(bundle, shakaPlayerVersion) {
    return _loadShakaVersionBundle.apply(this, arguments);
}
function _loadShakaVersionBundle() {
    _loadShakaVersionBundle = _async_to_generator(function(bundle, shakaPlayerVersion) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    switch(shakaPlayerVersion){
                        case ShakaPlayerVersion.V_41000:
                            return [
                                3,
                                1
                            ];
                        case ShakaPlayerVersion.V_3_3_10:
                            return [
                                3,
                                3
                            ];
                        case ShakaPlayerVersion.V_3_0_5:
                            return [
                                3,
                                5
                            ];
                    }
                    return [
                        3,
                        5
                    ];
                case 1:
                    return [
                        4,
                        loadShakaBundle_41000(bundle)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        loadShakaBundle_3_3_10(bundle)
                    ];
                case 4:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap" */ '@sky-uk-ott/shaka-player-3-0-5')
                    ];
                case 6:
                    self.shaka = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadShakaVersionBundle.apply(this, arguments);
}
function loadShakaBundle_41000(bundle) {
    return _loadShakaBundle_41000.apply(this, arguments);
}
function _loadShakaBundle_41000() {
    _loadShakaBundle_41000 = _async_to_generator(function(bundle) {
        var googModule, origAddDependency, emeModule;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    switch(bundle){
                        case ShakaBundle.ALL:
                            return [
                                3,
                                1
                            ];
                        case ShakaBundle.ALL_2015:
                            return [
                                3,
                                3
                            ];
                        case ShakaBundle.DASH_TTML_ES5:
                            return [
                                3,
                                5
                            ];
                        case ShakaBundle.DASH_TTML_ES2015:
                            return [
                                3,
                                7
                            ];
                        case ShakaBundle.DASH_VTT_ES5:
                            return [
                                3,
                                9
                            ];
                        case ShakaBundle.DASH_VTT_ES2015:
                            return [
                                3,
                                11
                            ];
                        case ShakaBundle.HLS_ES5:
                            return [
                                3,
                                13
                            ];
                        case ShakaBundle.HLS_ES2015:
                            return [
                                3,
                                15
                            ];
                        case ShakaBundle.DEBUG:
                            return [
                                3,
                                17
                            ];
                        case ShakaBundle.UNCOMPILED:
                            return [
                                3,
                                19
                            ];
                    }
                    return [
                        3,
                        25
                    ];
                case 1:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-all-es5" */ '@sky-uk-ott/shaka-player-41000')
                    ];
                case 2:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 3:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-all-es2015" */ '@sky-uk-ott/shaka-player-41000/all-es2015')
                    ];
                case 4:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 5:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-dash-ttml-es5" */ '@sky-uk-ott/shaka-player-41000/dash-ttml-es5')
                    ];
                case 6:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 7:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-dash-ttml-es2015" */ '@sky-uk-ott/shaka-player-41000/dash-ttml-es2015')
                    ];
                case 8:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 9:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-dash-vtt-es5" */ '@sky-uk-ott/shaka-player-41000/dash-vtt-es5')
                    ];
                case 10:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 11:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-dash-vtt-es2015" */ '@sky-uk-ott/shaka-player-41000/dash-vtt-es2015')
                    ];
                case 12:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 13:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-hls-es5" */ '@sky-uk-ott/shaka-player-41000/hls-es5')
                    ];
                case 14:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 15:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-hls-es2015" */ '@sky-uk-ott/shaka-player-41000/hls-es2015')
                    ];
                case 16:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 17:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-debug" */ '@sky-uk-ott/shaka-player-41000/debug')
                    ];
                case 18:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 19:
                    // Uncompiled will fail to attach to window if shaka instance is already there
                    self.shaka = undefined;
                    shakaWindow.CLOSURE_NO_DEPS = true;
                    // on webos, by the time we get here the document is in the complete readyState
                    // which messes up closure compiler library.
                    // Instead, we can force it to work by loading the scripts manually.
                    if (document.readyState === 'complete') {
                        shakaWindow.CLOSURE_IMPORT_SCRIPT = closureLibraryImportScript;
                    }
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-uncompiled-goog" */ '@sky-uk-ott/shaka-player-41000/goog')
                    ];
                case 20:
                    googModule = _state.sent();
                    origAddDependency = googModule.goog.addDependency;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Just a wrapper. Types unimportant.
                    googModule.goog.addDependency = function(relPath, provides, requires, flags) {
                        var paths = relPath.split('../');
                        relPath = [
                            'spv41000/'
                        ].concat(paths).join('');
                        origAddDependency(relPath, provides, requires, flags);
                    };
                    shakaWindow.goog = googModule.goog;
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-uncompiled-deps" */ '@sky-uk-ott/shaka-player-41000/deps')
                    ];
                case 21:
                    _state.sent();
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-uncompiled-asserts" */ '@sky-uk-ott/shaka-player-41000/asserts')
                    ];
                case 22:
                    _state.sent();
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-uncompiled-eme" */ '@sky-uk-ott/shaka-player-41000/eme')
                    ];
                case 23:
                    emeModule = _state.sent();
                    shakaWindow.EncryptionSchemePolyfills = emeModule.default;
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-41000-uncompiled" */ '@sky-uk-ott/shaka-player-41000/uncompiled')
                    ];
                case 24:
                    _state.sent();
                    return [
                        2,
                        new Promise(function(fulfill, reject) {
                            var check = function() {
                                var _self_shaka, _self_shaka_polyfill, _self_shaka1;
                                // gotta wait for the Player and installAll to load before proceeding
                                // as shaka is now loaded asynchronously but some things depend on these bits to be loaded
                                // @ts-ignore
                                if (((_self_shaka = self.shaka) === null || _self_shaka === void 0 ? void 0 : _self_shaka.Player) && ((_self_shaka1 = self.shaka) === null || _self_shaka1 === void 0 ? void 0 : (_self_shaka_polyfill = _self_shaka1.polyfill) === null || _self_shaka_polyfill === void 0 ? void 0 : _self_shaka_polyfill.installAll)) {
                                    fulfill();
                                } else {
                                    setTimeout(check, 100);
                                }
                            };
                            check();
                        })
                    ];
                case 25:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadShakaBundle_41000.apply(this, arguments);
}
function loadShakaBundle_3_3_10(bundle) {
    return _loadShakaBundle_3_3_10.apply(this, arguments);
}
function _loadShakaBundle_3_3_10() {
    _loadShakaBundle_3_3_10 = _async_to_generator(function(bundle) {
        var googModule, origAddDependency, emeModule;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    switch(bundle){
                        case ShakaBundle.ALL:
                            return [
                                3,
                                1
                            ];
                        case ShakaBundle.ALL_2015:
                            return [
                                3,
                                3
                            ];
                        case ShakaBundle.DASH_TTML_ES5:
                            return [
                                3,
                                5
                            ];
                        case ShakaBundle.DASH_TTML_ES2015:
                            return [
                                3,
                                7
                            ];
                        case ShakaBundle.DASH_VTT_ES5:
                            return [
                                3,
                                9
                            ];
                        case ShakaBundle.DASH_VTT_ES2015:
                            return [
                                3,
                                11
                            ];
                        case ShakaBundle.HLS_ES5:
                            return [
                                3,
                                13
                            ];
                        case ShakaBundle.HLS_ES2015:
                            return [
                                3,
                                15
                            ];
                        case ShakaBundle.DEBUG:
                            return [
                                3,
                                17
                            ];
                        case ShakaBundle.UNCOMPILED:
                            return [
                                3,
                                19
                            ];
                    }
                    return [
                        3,
                        25
                    ];
                case 1:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-all-es5" */ '@sky-uk-ott/shaka-player-3-3-10')
                    ];
                case 2:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 3:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-all-es2015" */ '@sky-uk-ott/shaka-player-3-3-10/all-es2015')
                    ];
                case 4:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 5:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-dash-ttml-es5" */ '@sky-uk-ott/shaka-player-3-3-10/dash-ttml-es5')
                    ];
                case 6:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 7:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-dash-ttml-es2015" */ '@sky-uk-ott/shaka-player-3-3-10/dash-ttml-es2015')
                    ];
                case 8:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 9:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-dash-vtt-es5" */ '@sky-uk-ott/shaka-player-3-3-10/dash-vtt-es5')
                    ];
                case 10:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 11:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-dash-vtt-es2015" */ '@sky-uk-ott/shaka-player-3-3-10/dash-vtt-es2015')
                    ];
                case 12:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 13:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-hls-es5" */ '@sky-uk-ott/shaka-player-3-3-10/hls-es5')
                    ];
                case 14:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 15:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-hls-es2015" */ '@sky-uk-ott/shaka-player-3-3-10/hls-es2015')
                    ];
                case 16:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 17:
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-debug" */ '@sky-uk-ott/shaka-player-3-3-10/debug')
                    ];
                case 18:
                    self.shaka = _state.sent();
                    return [
                        3,
                        25
                    ];
                case 19:
                    // Uncompiled will fail to attach to window if shaka instance is already there
                    self.shaka = undefined;
                    shakaWindow.CLOSURE_NO_DEPS = true;
                    // on webos, by the time we get here the document is in the complete readyState
                    // which messes up closure compiler library.
                    // Instead, we can force it to work by loading the scripts manually.
                    if (document.readyState === 'complete') {
                        shakaWindow.CLOSURE_IMPORT_SCRIPT = closureLibraryImportScript;
                    }
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-uncompiled-goog" */ '@sky-uk-ott/shaka-player-3-3-10/goog')
                    ];
                case 20:
                    googModule = _state.sent();
                    origAddDependency = googModule.goog.addDependency;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- Just a wrapper. Types unimportant.
                    googModule.goog.addDependency = function(relPath, provides, requires, flags) {
                        var paths = relPath.split('../');
                        relPath = [
                            'spv3/'
                        ].concat(paths).join('');
                        origAddDependency(relPath, provides, requires, flags);
                    };
                    shakaWindow.goog = googModule.goog;
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-uncompiled-deps" */ '@sky-uk-ott/shaka-player-3-3-10/deps')
                    ];
                case 21:
                    _state.sent();
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-uncompiled-asserts" */ '@sky-uk-ott/shaka-player-3-3-10/asserts')
                    ];
                case 22:
                    _state.sent();
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-uncompiled-eme" */ '@sky-uk-ott/shaka-player-3-3-10/eme')
                    ];
                case 23:
                    emeModule = _state.sent();
                    shakaWindow.EncryptionSchemePolyfills = emeModule.default;
                    return [
                        4,
                        import(/* webpackChunkName: "shakap-3-3-10-uncompiled" */ '@sky-uk-ott/shaka-player-3-3-10/uncompiled')
                    ];
                case 24:
                    _state.sent();
                    return [
                        2,
                        new Promise(function(fulfill, reject) {
                            var check = function() {
                                var _self_shaka, _self_shaka_polyfill, _self_shaka1;
                                // gotta wait for the Player and installAll to load before proceeding
                                // as shaka is now loaded asynchronously but some things depend on these bits to be loaded
                                // @ts-ignore
                                if (((_self_shaka = self.shaka) === null || _self_shaka === void 0 ? void 0 : _self_shaka.Player) && ((_self_shaka1 = self.shaka) === null || _self_shaka1 === void 0 ? void 0 : (_self_shaka_polyfill = _self_shaka1.polyfill) === null || _self_shaka_polyfill === void 0 ? void 0 : _self_shaka_polyfill.installAll)) {
                                    fulfill();
                                } else {
                                    setTimeout(check, 100);
                                }
                            };
                            check();
                        })
                    ];
                case 25:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadShakaBundle_3_3_10.apply(this, arguments);
}
function getAllBundle(esVersion) {
    if (esVersion === ShakaEcmaScriptVersion.ES5) {
        return ShakaBundle.ALL;
    } else if (esVersion === ShakaEcmaScriptVersion.ES_2015) {
        return ShakaBundle.ALL_2015;
    }
}
function getDashTTMLBundle(esVersion) {
    if (esVersion === ShakaEcmaScriptVersion.ES5) {
        return ShakaBundle.DASH_TTML_ES5;
    } else if (esVersion === ShakaEcmaScriptVersion.ES_2015) {
        return ShakaBundle.DASH_TTML_ES2015;
    }
}
function getDashVTTBundle(esVersion) {
    if (esVersion === ShakaEcmaScriptVersion.ES5) {
        return ShakaBundle.DASH_VTT_ES5;
    } else if (esVersion === ShakaEcmaScriptVersion.ES_2015) {
        return ShakaBundle.DASH_VTT_ES2015;
    }
}
function getHlsBundle(esVersion) {
    if (esVersion === ShakaEcmaScriptVersion.ES5) {
        return ShakaBundle.HLS_ES5;
    } else if (esVersion === ShakaEcmaScriptVersion.ES_2015) {
        return ShakaBundle.HLS_ES2015;
    }
}
function closureLibraryImportScript(src, opt_sourceText) {
    if (opt_sourceText) {
        eval(opt_sourceText);
    } else {
        var s = document.createElement('script');
        s.src = src;
        s.async = false;
        document.head.appendChild(s);
    }
    return true;
}
export function loadMuxJS(shakaVersion, useMuxJS) {
    return _loadMuxJS.apply(this, arguments);
}
function _loadMuxJS() {
    _loadMuxJS = _async_to_generator(function(shakaVersion, useMuxJS) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!// mux.js is needed for parsing of in stream subtitles (CEA) in old versions of shaka.
                    // https://github.com/google/shaka-player/commit/337c1a9f02d84a54613d0f2240186b9d88fed162
                    // This is currently the only supported way to provide muxjs as a dependency for shaka
                    // https://github.com/google/shaka-player/issues/2562
                    (useMuxJS || !isVersionCompliant(shakaVersion, MINIMUM_VERSION_FOR_NEW_CEA_PARSER))) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        import(/* webpackChunkName: "muxjs" */ '@sky-uk-ott/muxjs')
                    ];
                case 1:
                    self.muxjs = _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return _loadMuxJS.apply(this, arguments);
}

//# sourceMappingURL=shaka-loader.js.map